import React from 'react';
import {
    //calcAmountToBePaid,
    printDate,
    printCurrency,
    formatAddress
} from '../util/formatUtility';
import { translateResourceString } from '../util/translationUtility';

class Invoice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    handleSelected = (event) => {
        this.props.setSelected(this.props.data.OpenARId, event.target.checked);
    }

    handlePayChange = (event) => {
        let val = event.target.value.replace(/[^0-9.-]/g, '');
        if (val.match(/.+\.\d{3,}/g)) val = Number(val).toFixed(2).toString();
        if (val === this.props.data.amountToPay) return false;
        this.props.setAmountToPay(this.props.data.OpenARId, val);
    }

    handleOnBlur = (event) => {
        let val = event.target.value;
        if (this.props.data.Balance < 0 && Number(val) > 0 || this.props.data.Balance > 0 && Number(val) < 0) val = -val;
        this.props.setAmountToPay(this.props.data.OpenARId, Number(val).toFixed(2));
    }

    render() {
        const {
            data,
            useSummaryView
        } = this.props;

        const amountToPay = isNaN(data.amountToPay) ? 0 : data.amountToPay;
        const properPosNegAmountToPay = data.Balance > 0 ? Math.abs(amountToPay) : -Math.abs(amountToPay);
        const valid = Math.abs(amountToPay) <= Math.abs(data.Balance);

        //const accountNameAndAddress = `${data.AccountName} ${formatAddress(data.Address)}`;

        const rowClassNames = [valid ? "danger" : amountToPay ? "active" : ""];
        const dNoneInSummaryView = useSummaryView ? "d-none" : "";

        const notes = data.ReasonCode;

        return (
            <tr className={rowClassNames} >
                <td className={dNoneInSummaryView}>{!useSummaryView && <input type="checkbox" checked={data.isSelected} onChange={this.handleSelected} />}</td>
                <td>{!!data.CustomerNumber &&
                    <React.Fragment>
                        {translateResourceString("/MyAccountPage/InvoicePayments/CustomerNumberLabel")} {data.CustomerNumber}<br />
                    </React.Fragment>}
                    {data.AccountName}<br />
                    {formatAddress(data.Address)}
                </td>
                <td>
                    <a href={data.PdfUrl} target="blank">{data.AddlReferenceNumber}</a>
                </td>
                <td className={dNoneInSummaryView}>{notes}</td>
                <td className={dNoneInSummaryView}>{data.TransactionType}</td>
                <td className={dNoneInSummaryView}>{printDate(data.TransactionDate)}</td>
                <td className={dNoneInSummaryView}>{printDate(data.DueDate)}</td>
                <td className={data.Balance < 0 ? 'success' : 'info'}> {printCurrency(data.Balance)}</td>
                {/*<td>{useSummaryView*/}
                {/*    ? <React.Fragment>{printCurrency(amountToPay)}</React.Fragment>*/}
                {/*    : <React.Fragment>*/}
                {/*        {data.isSelected &&*/}
                {/*            <input type="text" className="form-control text-right" value={data.amountToPay}*/}
                {/*                onChange={this.handlePayChange} onBlur={this.handleOnBlur} />*/}
                {/*        }*/}
                {/*        {(data.isSelected && !valid) &&*/}
                {/*            <span>{translateResourceString("/MyAccountPage/InvoicePayments/AmountNotValidMessage")}</span>*/}
                {/*        }*/}
                {/*    </React.Fragment>*/}
                {/*}*/}
                {/*</td>*/}
                {/*<td className={dNoneInSummaryView}>{printCurrency(data.Balance - properPosNegAmountToPay)}</td>*/}
            </tr>
        );
    }
}

export default Invoice;